export class ValueChecked {
  public name: string;
  public checked: boolean;

  constructor(name: string, checked: boolean) {
    this.name = name;
    this.checked = checked;
  }
}
